import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
// import "../../../../custom.css";
import CustomTableLinesFooter from "./Footer";
import useTable from "./useTable";
import useWindowDimensions from "../../../../customhooks/useWindowDimensions";
import { ContactContext } from "../../../../context/contact/ContactContext";
import { useStyles } from "./style";

const CustomTableLines = ({ data, rowsPerPage }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { purchLines } = useContext(ContactContext);
  const { width } = useWindowDimensions();
  const [page, setPage] = useState(1);
  const [isfilter, setIsfilter] = useState(false);
  const [dataTemp, setDataTemp] = useState([]);

  if (purchLines.length > 0 && dataTemp.length === 0 && isfilter === false) {
    setDataTemp(purchLines);
  }
  const { slice, range } = useTable(dataTemp, page, rowsPerPage);
  const filter = (e) => {
    const keyword = e.target.value;
    if (keyword !== "") {
      setIsfilter(true);
      const results = purchLines.filter((dataT) => {
        return dataT[e.target.name].includes(keyword.toLowerCase());
      });
      setDataTemp(results);
    } else {
      setIsfilter(false);
      setDataTemp(purchLines);
    }
  };

  return (
    <>
      <br />
      <h1 className={classes.h1Custom}>
        {t("purchaseOrderDetail", { PurchId: data.purchId })}
      </h1>
      <br />
      <CustomTableLinesFooter
        range={range}
        slice={slice}
        setPage={setPage}
        page={page}
        side={1}
      />
      <Table className="table">
        <Thead className="tableRowHeader">
          <Tr>
            <Th className="tableHeader">{t("itemId")}</Th>
            <Th className="tableHeader">{t("itemName")}</Th>
            <Th className="tableHeader">{t("manufacturerId")}</Th>
            <Th className="tableHeader">{t("manufacturerName")}</Th>
            <Th className="tableHeader">{t("qty")}</Th>
            <Th className="tableHeader">{t("unit")}</Th>
            <Th className="tableHeader">{t("unitPrice")}</Th>
            <Th className="tableHeader">{t("netAmount")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {slice.length > 0 &&
            slice.map((item, index) => (
              <Tr className="tableRowItems" key={index}>
                <Td className="tableCell">{item.itemId}</Td>
                <Td className="tableCell">{item.itemName}</Td>
                <Td className="tableCell">{item.bphManufacturerId}</Td>
                <Td className="tableCell">{item.bphManufacturerName}</Td>
                <Td className="tableCell">{item.purchQty}</Td>
                <Td className="tableCell">{item.purchUnit}</Td>
                <Td className="tableCell">{item.purchPrice}</Td>
                <Td className="tableCell">{item.lineAmount}</Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
      <CustomTableLinesFooter
        range={range}
        slice={slice}
        setPage={setPage}
        page={page}
        side={2}
      />
    </>
  );
};

export default CustomTableLines;
